module.exports = "/_next/static/images/7c4af89bba3c5aebb08bf444f0b6bec1-doggo-lg.jpg";